import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { Batch, BatchInsert, BatchSearchCommand, BatchStatus } from '../../models/production/production-work-order';

@Injectable({
  providedIn: 'root',
})
export class BatchProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.productionApi}/api/v1/batch`;

  getById(id: string): Observable<ApiResponse<Batch>> {
    return this.httpClient.get<ApiResponse<Batch>>(`${this.baseUrl}/${id}`);
  }

  getByIds(ids: string[]): Observable<ApiResponse<Batch[]>> {
    return this.httpClient.post<ApiResponse<Batch[]>>(`${this.baseUrl}/ids`, ids);
  }

  getByInitiatorReference(initiatorReference: string): Observable<ApiResponse<Batch[]>> {
    return this.httpClient.get<ApiResponse<Batch[]>>(`${this.baseUrl}/initiator/${initiatorReference}`);
  }

  create(command: BatchInsert): Observable<ApiResponse<Batch>> {
    return this.httpClient.post<ApiResponse<Batch>>(this.baseUrl, command);
  }

  update(id: string, batch: Batch): Observable<ApiResponse<void>> {
    return this.httpClient.put<ApiResponse<void>>(`${this.baseUrl}/${id}`, batch);
  }

  updateStatus(id: string, status: BatchStatus): Observable<ApiResponse<Batch>> {
    return this.httpClient.patch<ApiResponse<Batch>>(`${this.baseUrl}/${id}/status`, status);
  }

  search(
    command: BatchSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<Batch>>> {
    let params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());
    if (sortField) {
      params = params.set('sortField', sortField).set('sortOrder', sortOrder.toString());
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Batch>>>(`${this.baseUrl}/search`, command, { params });
  }
}
